module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAARElEQVQYlWM8cODAfwYocHBwYMAGDhw4AGczYVWBB7DgMw2brSzogshsdM2UOQmbU7AFAoYfkAF1nYQrDrBqwGY1LgAAIkQWH/yy2t0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/RESTORE.png
// module id = 94
// module chunks = 0